import React from "react";
import "./PartneredBanks.css";

import yesBankLogo from "../../../src/assets/images/yesbank.png";
import avanseLogo from "../../../src/assets/images/avanse.png";
import auxiloLogo from "../../../src/assets/images/auxilo.png";
import iciciLogo from "../../../src/assets/images/icici.png";
import axisLogo from "../../../src/assets/images/axis.png";
import credilaLogo from "../../../src/assets/images/credila.png";

const banks = [
  { name: "Yes Bank", logo: yesBankLogo },
  { name: "Avanse", logo: avanseLogo },
  { name: "Auxilo", logo: auxiloLogo },
  { name: "ICICI Bank", logo: iciciLogo },
  { name: "Axis Bank", logo: axisLogo, note: "All documents physically required" },
  { name: "Credila", logo: credilaLogo },
];

export default function PartneredBanks() {
  return (
    <div className="partnered-banks">
      <h2 className="partnered-title">Our Partnered Banks & NBFCs</h2>
      <div className="bank-grid">
        {banks.map((bank, index) => (
          <div className="bank-item" key={index}>
            <img src={bank.logo} alt={bank.name} />
            <h4>{bank.name}</h4>
            {bank.note && <p>{bank.note}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
